import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import api from "@/lib/api";
import useSeo from "@/lib/useSeo";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useSeo({ title: "Testimonials | Healthy Roots Holistics", description: "Read what our clients say about their healing journey with Healthy Roots." });
  useEffect(() => { api.get("/public/testimonials").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div className="pt-28 pb-24" data-testid="testimonials-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-sm uppercase tracking-widest text-emerald-700 font-semibold">Client Stories</span>
          <h1 className="text-4xl sm:text-5xl mt-2 text-emerald-950">What Our Clients Say</h1>
          <p className="text-stone-600 mt-4">After many successful consultations, our clients have experienced profound and lasting results.</p>
        </div>
        <div className="grid gap-7 md:grid-cols-2">
          {items.map((t) => (
            <blockquote key={t.id} className="bg-white rounded-3xl p-8 border border-stone-200/80 shadow-sm">
              <Quote className="text-emerald-300 mb-4" size={32} />
              <p className="text-stone-700 italic leading-relaxed mb-5">{t.quote}</p>
              <footer className="font-semibold text-emerald-800">— {t.author}</footer>
            </blockquote>
          ))}
        </div>
      </div>
    </div>
  );
}
